import { MutationTree } from 'vuex';
import { IModuleAppointmentState } from '../types';
import { deepClone } from 'fast-json-patch';
export const mutations: MutationTree<IModuleAppointmentState> = {
    fetchAppointments(state) {
        state.loading = true;
    },
    fetchAppointmentsSuccess(state, payload) {
        state.appointments = [];
        state.appointments = deepClone(payload.data.GetAppointmentObjectJsonResult);
        state.loading = false;
    },
    fetchProperty(state) {
        state.loading = true;
    },
    fetchPropertySuccess(state, payload) {
        state.property = null;
        state.property = deepClone(payload.data.GetPropertyJsonResult.Value);
        state.loading = false;
    },
    syncAppointmentClick(state, payload) {
        state.appointmentClicked = payload.id;
    },
    sendContact(state) {
        state.statusSendForm.loading = true;
    },
    sendContactSuccess(state, payload) {
        state.statusSendForm.loading = false;
        state.statusSendForm.status = payload.message;
    },
};
